import { get } from 'lodash';

export default ({
  modifiedPNRModel, 
  storefront, 
}) => {
  const {
    confirmationModel,
    flightItineraryType,
  } = modifiedPNRModel;
  const totalPaied = get(confirmationModel, 'cartConfirmation.total', null);
  const language = storefront.split('-');

  return {
    event: 'FareLock',
    eventAction: 'Paid',
    eventCategory: 'MYB',
    eventLabel: modifiedPNRModel.getAllFareFamilies(),
    'flight_type': flightItineraryType ? flightItineraryType : '',
    origin: modifiedPNRModel.getOriginCode(),
    destination: modifiedPNRModel.getDestinationCode(),
    storefront: storefront,
    language: language[1],
    currencyCode: totalPaied ? totalPaied.currencyCode : 'NA',
    revenue: totalPaied ? totalPaied.total : 0,
  };
};